export default "__VITE_ASSET__720f93f5__"